const ComponentEditorComponent = {
    templateUrl: '/formViewer/editor/componentEditor.tpl.html',
    controller: 'componentEditorController',
    bindings: {
        componentStructure: '<',
        rootFormId: '<'
    }
};

angular.module('umFormViewer')
    .component('uiComponentEditor', ComponentEditorComponent);
